import { StyleSheet } from 'react-native';
import { Buttons } from 'src/theme-v2/buttons';

export const styles = StyleSheet.create({
  button: {
    backgroundColor: Buttons.secondary.ButtonSecondaryBackgroundDefault,
    borderWidth: 1,
    borderColor: Buttons.secondary.ButtonSecondaryStrokeDefault,
  },
  buttonInner: {},
  buttonHover: {
    backgroundColor: Buttons.secondary.ButtonSecondaryBackgroundHover,
  },
  buttonPressed: {
    backgroundColor: Buttons.secondary.ButtonSecondaryBackgroundPressed,
  },
  buttonFocus: {
    backgroundColor: Buttons.secondary.ButtonSecondaryBackgroundDefault,
  },
  buttonDisabled: {
    cursor: 'not-allowed',
    backgroundColor: Buttons.secondary.ButtonSecondaryBackgroundDefault,
    borderColor: Buttons.secondary.ButtonSecondaryStrokeDisable,
  },
  text: {
    fontSize: 16,
    fontWeight: 700,
    lineHeight: 20,
    textAlign: 'center',
    color: Buttons.secondary.ButtonSecondaryTextDefault,
  },
  textHover: { color: Buttons.secondary.ButtonSecondaryTextDefault },
  textPressed: { color: Buttons.secondary.ButtonSecondaryTextDefault },
  textFocus: { color: Buttons.secondary.ButtonSecondaryTextDefault },
  textDisabled: {
    color: Buttons.secondary.ButtonSecondaryTextDisable,
  },
  icon: {
    color: Buttons.secondary.ButtonSecondaryIconDefault,
  },
  iconHover: {
    color: Buttons.secondary.ButtonSecondaryIconDefault,
  },
  iconPressed: {
    color: Buttons.secondary.ButtonSecondaryIconDefault,
  },
  iconDisabled: {
    color: Buttons.secondary.ButtonSecondaryIconDisable,
  },
  iconFocus: {
    color: Buttons.secondary.ButtonSecondaryIconDefault,
  },
});
